import size from "lodash/size";

export const needTooltip = (list: any[]) => size(list) >= 2;
